import moment from 'moment';

export const formatDate = (date) => {
  if (!date || !moment(date).isValid()) {
    return date;
  }
  return moment(date).format('DD/MM/YYYY');
};

export const formatCompleteDate = (date, showSeconds = true) => {
  if (!date || !moment(date).isValid()) {
    return date;
  }
  return moment(date).format(
    showSeconds ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY HH:mm',
  );
};

export const UQBAR_TIMEZONE = 'America/Sao_Paulo';
export const UQBAR_DATE_FORMAT = 'YYYY-MM-DD';
